// extracted by mini-css-extract-plugin
export default {"cell":"Request_cell__eK+I6","flex":"Request_flex__Ein3a","block":"Request_block__Vum14"};